import axios from "axios"

// For common config
// axios.defaults.headers.post["Content-Type"] = "application/json";

const healthInstance = axios.create({
    baseURL: process.env.GATSBY_HEALTH_API,
    headers: {
        "Content-type": "application/json",
    },
})

const schedulerInstance = axios.create({
    baseURL: process.env.GATSBY_SCHEDULER_API,
    headers: {
        "Content-type": "application/json",
    },
})

const docAssistInstance = axios.create({
    baseURL: process.env.GATSBY_DOCASSIST_API,
    headers: {
        "Content-type": "application/json",
    },
})

const journalInstance = axios.create({
    baseURL: process.env.GATSBY_JOURNAL_API,
    headers: {
        "Content-type": "application/json",
    },
})

const authInstance = axios.create({
    baseURL: process.env.GATSBY_AUTH_API,
    headers: {
        // "Content-type": "application/json",
    },
})

const lambdaInstance = axios.create({
    baseURL: process.env.GATSBY_TWILIO_CALL_LOGS_API,
    headers: {
        // "Content-type": "application/json",
    },
})

const chatGPTInstance = axios.create({
    baseURL: process.env.GATSBY_CARE_PLAN_AI_API,
    headers: {
        // "Content-type": "application/json",
    },
})

const gptInstance = axios.create({
    baseURL: process.env.GATSBY_GPT_API,
    headers: {
        // "Content-type": "application/json",
    },
})

const twilioInstance = axios.create({
    baseURL: process.env.GATSBY_TWILIO_API,
    headers: {
        // "Content-type": "application/json",
    },
})

const carePlanAiInstance = axios.create({
    baseURL: process.env.GATSBY_CARE_PLAN_AI_API,
    headers: {
        "Content-type": "application/json",
    },
})

const DoctoriteAiInstance = axios.create({
    baseURL: process.env.GATSBY_AI_API,
    headers: {
        "Content-type": "application/json",
    },
})

// Stripe service (stripe/ repo). Every /api/* route there validates the
// caller's login token via user/userProfile, so this gets the same request
// interceptor as healthInstance (see axiosRequest.js).
const stripeInstance = axios.create({
    baseURL: process.env.GATSBY_STRIPE_API_URL,
    headers: {
        "Content-type": "application/json",
    },
})

// Google Calendar service (google-calendar/ repo). Its routes validate the
// caller's login token via user/userProfile the same way the Stripe service
// does, so this also gets healthInstance's request interceptor.
const googleCalendarInstance = axios.create({
    baseURL: process.env.GATSBY_CALENDAR_BACKEND_URL,
    headers: {
        "Content-type": "application/json",
    },
})

export {
    healthInstance,
    schedulerInstance,
    journalInstance,
    authInstance,
    lambdaInstance,
    chatGPTInstance,
    gptInstance,
    twilioInstance,
    carePlanAiInstance,
    DoctoriteAiInstance,
    docAssistInstance,
    stripeInstance,
    googleCalendarInstance,
}
